import AppBar from '@mui/material/AppBar';
import ListItem from '@mui/material/ListItem';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Button from '@core/design-system/button';
import List from '@mui/material/List';

import { styled } from '@mui/material';

export const AppHeader = styled(AppBar)`
  background-color: ${(props) => props.theme.palette.primary.main};
  padding: 0;
  @media print {
    position: relative !important;
    top: 0;

    @page {
      size: 1080px 1920px;
    }
  }
`;

export const StyledToolbar = styled(Toolbar)`
  position: relative;
  display: flex;

  ${(props) => props.theme.breakpoints.down('lg')} {
    justify-content: center;
  }
`;

export const StyledBox = styled(Box)`
  position: absolute;
  display: flex;
  align-items: center;
  right: 0;
`;

export const StyledIconButton = styled('button')`
  position: absolute;
  border: none;
  background: transparent;
  color: ${(props) => props.theme.palette.white.main};
  cursor: pointer;
  left: 10px;

  ${(props) => props.theme.breakpoints.up('lg')} {
    display: none;
  }

  ${(props) => props.theme.breakpoints.down('lg')} {
    display: block;
  }

  @media print {
    display: none;
  }
`;

export const StyledLinkItem = styled<any>(ListItem)`
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  &.MuiLink-underlineHover:hover {
    text-decoration: none;
  }
`;

export const SocialNetWorksContainer = styled('div')`
  width: 100%;
  margin-top: ${(props) => props.theme.spacing(4)};
`;

export const HiddenH1 = styled('h1')`
  margin: 0;
  text-indent: -99999px;
  white-space: nowrap;
  overflow: hidden;
  height: 0;
`;

export const NavbarContainerAMP = styled('header')`
  width: 100%;
  background-color: #0f132a;
  padding-left: 20px;
  padding-right: 20px;
  position: sticky;
  top: 0;
  z-index: 999;

  .navbar-wrapper {
    height: 70px;
    max-width: 1380px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
  }

  .iconContainer {
    color: #fff;
    background-color: transparent;
    border: 0;
    outline: 0;
    cursor: pointer;
  }
`;

export const NavbarSidebarAMP = styled('div')`
  .sidebar {
    max-width: 350px;
    width: 80%;
    background-color: #0f132a;
    height: 100%;
  }

  .menuItemContainer {
    padding: 8px 16px;
  }

  .menuContainer {
    margin-top: 20px;
    padding: 0 10px;
    padding-bottom: 30px;
  }

  .sidebarTitle {
    text-decoration: none;
    color: #fff;
    font-size: ${(theme) => theme.theme.typography.body1.fontSize};
    border: 0;
  }
`;

export const NavbarSearchContainer = styled('div')`
  .searchModal {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.95);
    height: 100%;
  }

  .headerSearchModal {
    height: 80px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
  }

  .closeModalButton {
    color: #fff;
    background-color: #0f132a;
    border-radius: 50px;
    padding: 10px;
    border: 0;
    outline: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .searchInputContainer {
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 24px;
  }

  .searchInput {
    height: 50px;
    max-width: 1000px;
    width: 100%;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    background-color: transparent;
    padding: 5px;
    outline: 0;
  }

  .searchInput::placeholder {
    font-size: ${(theme) => theme.theme.typography.h6.fontSize};
  }

  .searchInput:-ms-input-placeholder {
    font-size: ${(theme) => theme.theme.typography.h6.fontSize};
  }

  .searchInput::-ms-input-placeholder {
    font-size: ${(theme) => theme.theme.typography.h6.fontSize};
  }

  .searchButton {
    color: #fff;
    background-color: #0f132a;
    padding: 10px 30px;
    font-size: ${(theme) => theme.theme.typography.body2.fontSize};
    font-weight: 700;
    line-height: 1.75;
    border-radius: 20px;
    border: 0;
    text-transform: uppercase;
    cursor: pointer;
    margin-left: 20px;
  }
`;

export const Container = styled(Box)`
  margin-right: 16px;

  @media (max-width: 1260px) {
    margin-right: 8px;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`;

export const StyledList = styled(List)`
  margin-top: 5px;
  background-color: #0f132a;
`;

export const StyledListItem = styled('li')<{
  color?: string;
  padding?: string;
}>`
  padding: 0;
  a {
    min-width: 130px;
    width: 100%;
    padding: 2px 15px;
    display: flex;
    align-items: center;
    color: ${(props) => props.color || 'black'};

    &:hover {
      text-decoration-color: ${(props) => props.theme.palette.secondary.main};
      text-underline-offset: 8px;
    }
  }
`;

export const StyledMenuOption = styled(Button)<{ color?: string }>`
  display: flex;
  align-items: center;
  padding: 1px;
  text-transform: none;

  &:hover {
    border-bottom: 1px solid ${(theme) => theme.theme.palette.secondary.main};
    border-radius: 0px;
  }

  ${(props) => props.theme.breakpoints.down('lg')} {
    display: none;
  }
`;
